import React, { useEffect, useState } from "react";
import "./testing.css";
import { useEventsContext } from "src/hooks/use-alert";
import { Grid, Select, MenuItem, FormControl, InputLabel } from "@mui/material";

export const AlertGrid = () => {
  const { events } = useEventsContext();
  const [alerts, setAlerts] = useState([]);
  const [eventsSize, setEventsSize] = useState(5);
  useEffect(() => {
    setAlerts(events.data);
  }, [events.data]);

  const handleSizeChange = (e) => {
    const value = e.target.value;
    setEventsSize(value);
  };

  return (
    <Grid container>
      <table
        style={{
          paddingBottom: "20px",
        }}
      >
        <thead>
          <tr>
            <th>Status Icon</th>
            <th>Title</th>
            <th>Position</th>
            <th>Type</th>
            <th>Value</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {alerts.slice(-eventsSize).map((alert) => (
            <tr key={alert.id}>
              <td className="alertCardIcon">{alert.icon}</td>
              <td>{alert.title}</td>
              <td>{alert.position}</td>
              <td>{alert.type}</td>
              <td>{alert.value}</td>
              <td>{alert.date}</td>
            </tr>
          ))}
        </tbody>
        <tfoot
          style={{
            width: `calc(100% - 140px)`,
            background: "#282b30",
            position: "fixed",
            bottom: 0,
            borderTop: "1px solid",
          }}
        >
          <tr
            style={{
              float: "right",
            }}
          >
            <td
              className="sortBy"
              style={{
                height: "auto",
              }}
            >
              <FormControl>
                <Select value={eventsSize} onChange={handleSizeChange}>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={0}>all</MenuItem>
                </Select>
              </FormControl>
            </td>
          </tr>
        </tfoot>
      </table>
    </Grid>
  );
};

const AlertApp = () => {
  return (
    <div className="alert-app">
      <AlertGrid />
    </div>
  );
};

export default AlertApp;
